import AutoSubmitControl from '@/js/Controls/AutoSubmitControl'
import CarouselControl from '@/js/Controls/CarouselControl'
import DetectStuck from '@/js/Controls/DetectStuck'
import CollapsableControl from '@/js/Controls/CollapsableControl'
import FulltextControl from '@/js/Controls/FulltextControl'
import PackageUnitConverterControl from '@/js/Controls/PackageUnitConverterControl'
import QuantityInputControl from '@/js/Controls/QuantityInputControl'
import TooltipControl from '@/js/Controls/TooltipControl'
import { ControlManager } from '@peckadesign/pd-naja'
import naja from 'naja'

export const controlManager = new ControlManager(naja)

// Sorted by priority of initialization
controlManager.addControlOnLive(CollapsableControl)

controlManager.addControlOnLive(DetectStuck)

controlManager.addControlOnLive(CarouselControl)

controlManager.addControlOnLoad(FulltextControl)
controlManager.addControlOnLive(TooltipControl)
controlManager.addControlOnLive(QuantityInputControl)
controlManager.addControlOnLive(PackageUnitConverterControl)
controlManager.addControlOnLive(AutoSubmitControl)
